module.exports = __webpack_public_path__ + "static/media/clapping-hands-svgrepo-com.4980428b.svg";